import { render, staticRenderFns } from "./XeroSignUpComplete.vue?vue&type=template&id=2258740e&"
import script from "./XeroSignUpComplete.vue?vue&type=script&lang=js&"
export * from "./XeroSignUpComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports